import script from "./SubscriptionTelegramPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionTelegramPopup.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionTelegramPopup.vue?vue&type=style&index=0&id=0cc5c568&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc5c568"]])

export default __exports__